import { Utils } from '@src/utils/Utils';

const axios: any = require('axios');
const queryString = require('querystring');

const API_ENDPOINT: string = Utils.getBodyData('api');
const APPLICATION_KEY: string = Utils.getBodyData('apikey');

export namespace Axios {
    export interface IAxiosBaseResponse {
        successful: boolean;
        data?: any;
        message?: string;
    }

    export interface IResponse extends IAxiosBaseResponse {
        networkError: boolean;
        command: string;
        errorCode?: string;
    }

    export class AxiosApi {
        public static async get(url: string): Promise<IAxiosBaseResponse> {
            return axios
                .get(url, { withCredentials: true })
                .then((response: any): IAxiosBaseResponse => {
                    return {
                        successful: true,
                        data: response.data,
                    };
                })
                .catch((response: any): IAxiosBaseResponse => {
                    return {
                        successful: false,
                        data: {},
                    };
                });
        }

        public static async post(
            COMMAND: string,
            PARAMS: any = {},
            ENDPOINT: string = API_ENDPOINT,
        ) {
            const ALL_PARAMS: any = {
                APPLICATION_KEY,
                RESPONSE_TYPE: 'JSON',
                OS: 'web',
                OS_VERSION: 1,
                DEVICE_ID: 1,
                ...PARAMS,
                COMMAND,
            };
            const CONFIG: any = {
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded; charset=UTF-8',
                },
            };

            return axios
                .post(
                    `${ENDPOINT}`,
                    queryString.stringify(ALL_PARAMS),
                    CONFIG,
                )
                .then((response: any): IResponse => {
                    const successful: boolean =
                        response.data.successful === '1';

                    const getMessage = (obj: any): string => {
                        const messages = [
                            'message',
                            'error_message',
                            'error_description',
                        ];
                        for (var key in messages) {
                            const messageKey: any = messages[key];
                            if (obj[messageKey]) {
                                return obj[messageKey];
                            }
                        }
                        return null;
                    };

                    return {
                        networkError: false,
                        data: response.data,
                        command: COMMAND,
                        successful,
                        message: getMessage(response.data),
                    };
                })
                .catch((error: any): IResponse => {
                    if (error.response) {
                        // The request was made, but the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(
                            'AXIOS API | Error - 1: ',
                            error.response.data,
                        );
                        console.log(
                            'AXIOS API | Error - 1: ',
                            error.response.status,
                        );
                        console.log(
                            'AXIOS API | Error - 1: ',
                            error.response.headers,
                        );
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log('AXIOS API | Error - 2: ', error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('AXIOS API | Error - 3: ', error.message);
                    }

                    return {
                        networkError: true,
                        data: false,
                        command: COMMAND,
                        successful: false,
                    };
                });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/axios/Axios.ts